import { Classes } from '@blueprintjs/core'
import React, { useState } from 'react'
import styled from 'styled-components'

const getAvatarUrl = (email: string) =>
  `https://avatars.apple.com/a?mail=${encodeURIComponent(email)}`

type Props = {
  email?: string
  displayName?: string
  isCurrentUser: boolean
  isLoading: boolean
}

const Avatar = (props: Props) => {
  const { email, displayName, isCurrentUser, isLoading } = props
  const src = email ? getAvatarUrl(email) : undefined
  const [hasImageError, setHasImageError] = useState(false)

  const handleError = () => {
    setHasImageError(true)
  }

  if (isLoading) {
    return (
      <Wrapper isCurrentUser={isCurrentUser} className={Classes.SKELETON}>
        <CircularImage />
      </Wrapper>
    )
  }

  return (
    <Wrapper isCurrentUser={isCurrentUser}>
      {!hasImageError && src ? (
        <CircularImage alt={displayName} onError={handleError} src={src} />
      ) : (
        <div className="inner-circle">N/A</div>
      )}
    </Wrapper>
  )
}

export default Avatar

const CircularImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50px;
  box-shadow: inset 0 0 0 1px hsla(0, 0%, 0%, 0.1);
  padding: 1px;
`
const Wrapper = styled.div<{ isCurrentUser: boolean }>`
  align-self: flex-end;
  width: 32px;
  height: 32px;
  margin-right: ${(props) => {
    return props.isCurrentUser ? 0 : '6px'
  }};
  margin-left: ${(props) => {
    return props.isCurrentUser ? '6px' : 0
  }};
`
